<template>
  <div>
    <base-header class="bg-vg-gradient pb-6 pb-8 pt-5 pt-md-8"></base-header>
    <div class="container-fluid mt--9">
      <div class="row">
        <div class="col-12">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3 class="mb-0">Yetkili Oluştur</h3>
                </div>
              </div>
            </div>

            <div v-loading="loading">
              <el-form :model="formData" ref="formData" label-width="100px" :rules="rules" label-position="top">

                <div class="row">
                  <div class="col-lg-6">
                    <div class="has-label"><label class="form-control-label">
                      İsim</label>
                    </div>
                    <el-form-item prop="name" class="form-control-alternative">
                      <el-input class="form-control-alternative" v-model="formData.name" placeholder="İsim"></el-input>
                    </el-form-item>
                  </div>
                  <div class="col-lg-6">
                    <div class="has-label"><label class="form-control-label">
                      Soyisim</label>
                    </div>
                    <el-form-item prop="surname" class="form-control-alternative">
                      <el-input class="form-control-alternative" v-model="formData.surname"
                                placeholder="Soyisim"></el-input>
                    </el-form-item>
                  </div>
                  <div class="col-lg-12">
                    <div class="has-label"><label class="form-control-label">
                      E-Posta</label>
                    </div>
                    <el-form-item prop="email" class="form-control-alternative">
                      <el-input class="form-control-alternative" v-model="formData.email"
                                placeholder="E-Posta"></el-input>
                    </el-form-item>
                  </div>

                  <div class="col-lg-6">
                    <div class="has-label"><label class="form-control-label">
                      Şifre</label>
                    </div>
                    <el-form-item prop="password" class="form-control-alternative">
                      <el-input class="form-control-alternative" type="password" v-model="formData.password"
                                placeholder="Şifre"></el-input>
                    </el-form-item>
                  </div>
                  <div class="col-lg-6">
                    <div class="has-label"><label class="form-control-label">
                      Şifre Tekrarı</label>
                    </div>
                    <el-form-item prop="repassword" class="form-control-alternative">
                      <el-input type="password" class="form-control-alternative" v-model="formData.repassword"
                                placeholder="Şifre Tekrarı"></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="float-right mt-2">
                      <el-button size="small" type="success" @click="submitForm('formData')">Yetkili Ekle</el-button>
                    </div>
                  </div>
                </div>
              </el-form>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as axios from "axios";

export default {
  name: "CompanyUserCreate",
  data() {
    return {
      formData: {
        name: '',
        surname: '',
        email: '',
        password: '',
        repassword: '',
        company_id:'',
      },
      loading: false,
      rules: {
        name: [
          {required: true, message: 'Bu alan gereklidir.', trigger: 'blur'},
        ],
        surname: [
          {required: true, message: 'Bu alan gereklidir.', trigger: 'blur'},
        ],
        email: [
          {required: true, message: 'Bu alan gereklidir.', trigger: 'blur'},
        ],
        password: [
          {required: true, message: 'Bu alan gereklidir.', trigger: 'blur'},
        ],
        repassword: [
          {
            required: true,
            message: 'Bu alan gereklidir.',
            trigger: 'blur'
          },
        ],
      },
    }
  },
  created() {
    this.formData.company_id = this.$route.params.id;
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveUser();
        } else {
          return false;
        }
      });
    },
    saveUser() {
      this.loading = true;
      axios.post("admin/create-company-user", this.formData).then(() => {
        this.loading = false;
        this.$notify.success({
          title: 'Başarılı',
          message: 'Yetkili oluşturuldu.',
        });
      })
          .catch((error) => {
            this.loading = false;
            this.$notify.error({
              title: 'Hata',
              message: 'Bir hata meydana geldi.'
            });
            console.log(error)
          })
    }
  }
}
</script>

<style scoped>

</style>